import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Colleague } from '../types/colleague.type'

export type ColleaguesState = Colleague[]

const initialState: ColleaguesState = [
  {
    title: 'asd',
    name: 'Tori Broughton',
    favorite: false,
    id: 1
  },
  {
    title: 'asd',
    name: 'Marcie Tyson',
    favorite: false,
    id: 2
  },
  {
    title: 'asd',
    name: 'Zaydan Navarro',
    favorite: false,
    id: 3
  },
  {
    title: 'asd',
    name: 'Carmen tzui',
    favorite: false,
    id: 4
  },
  {
    title: 'asd',
    name: 'Leanna Bosdfgdfgwman',
    favorite: false,
    id: 5
  },
  {
    title: 'asd',
    name: 'Tori asdfasdf',
    favorite: false,
    id: 6
  },
  {
    title: 'asd',
    name: 'Marcie Tysfdfson',
    favorite: false,
    id: 7
  },
  {
    title: 'asd',
    name: 'Zaydan Navarro',
    favorite: false,
    id: 8
  },
  {
    title: 'asd',
    name: 'Carmen sdfgsdfg',
    favorite: false,
    id: 9
  },
  {
    title: 'asd',
    name: 'Leanna Bowman',
    favorite: false,
    id: 10
  }
]

export const colleaguesSlice = createSlice({
  name: 'colleagues',
  initialState,
  reducers: {
    addColleague: (state, action: PayloadAction<Colleague>) => {
      state.push(action.payload)
    },
    removeColleague: (state, action: PayloadAction<{ colleagueId: number }>) => {
      state = state.filter((colleague) => colleague.id !== action.payload.colleagueId)
      return state
    },
    favoriteColleague: (
      state,
      action: PayloadAction<{ colleagueId: number; favorite: boolean }>
    ) => {
      const colleagueToFavorite = state.find(
        (colleague) => colleague.id === action.payload.colleagueId
      )
      if (colleagueToFavorite) {
        colleagueToFavorite.favorite = action.payload.favorite
      }
    }
  }
})

export const { addColleague, removeColleague, favoriteColleague } = colleaguesSlice.actions

export const { reducer: colleaguesReducer } = colleaguesSlice
